import { render, staticRenderFns } from "./AnimatedBar.vue?vue&type=template&id=24d5cf78&scoped=true"
import script from "./AnimatedBar.vue?vue&type=script&lang=js"
export * from "./AnimatedBar.vue?vue&type=script&lang=js"
import style0 from "./AnimatedBar.vue?vue&type=style&index=0&id=24d5cf78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5cf78",
  null
  
)

export default component.exports